/* eslint-disable camelcase */
import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import 'animate.css';
import Background from '../../../assets/img/onboarding/backgrounds/background.png';
import { OnboardingTopBar } from '../OnboardingTopBar';
import { Start } from './Start';

interface OnboardingStartProps {
  onNextStep: () => void;
}

export const OnboardingStart = ({ onNextStep }: OnboardingStartProps) => {
  return (
    <Grid
      sx={{
        height: `100vh`,
        width: `100vw`,
        display: `flex`,
        flexDirection: `row`,
        justifyContent: `center`,
      }}
    >
      <Grid
        style={{
          position: `absolute`,
          inset: 0,
          backgroundImage: `url(${Background})`,
          backgroundSize: `cover`,
        }}
      />

      <Grid
        sx={{
          height: `100%`,
          width: `100 %`,
          display: `flex`,
          flexDirection: `row`,
          justifyContent: `center`,
          alignItems: `center`,
        }}
      >
        <Grid display="flex" flexDirection="column">
          <OnboardingTopBar color={RoutalPalette.neutral00} />
          <Start
            onNextStep={() => {
              onNextStep();
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
